<div class="msg-atch-tmp">
  <one-table>
    <one-table-content>
      <mat-table [dataSource]="dataSource" matSort multiTemplateDataRows
                 cdkDropList
                 [cdkDropListData]="dataSource.data"
                 (cdkDropListDropped)="drop($event)">

        <ng-container matColumnDef="dragHandle">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let element">
            <mat-icon class="drag-handle-icon">drag_indicator</mat-icon>
          </mat-cell>
        </ng-container>

        <!-- {{row.selectText}}      style="position: absolute; margin-left: 5%;" display: inline-table; width: 80%;   -->

        <ng-container matColumnDef="selectText">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let row" style="position: absolute; margin-left: 5%;">
            <!--   [checked]="selection.isSelected(row)" -->
            <mat-radio-button class="radio-button" (change)="$event ? selection.toggle(row) : null; selectedRow = row; updateSelectRowStatus();"
                              (click)="$event.stopPropagation()"
                              [disabled]="row.iconSets === 'yes-icon'">
              {{row.templateDetails.templateSubject}}
            </mat-radio-button>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="messageTemplate">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div style="max-width:83%; margin-left: 5%; margin-top: 7%;">
              <dl-rich-text-document class="cdk-hide-rich-text-doc" [jsonTextItem]="element.templateDetails.templateBody" [showInEditor]="'template'"></dl-rich-text-document>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="iconSets">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let element; let inx = dataIndex" style="position: absolute; margin-left: 87%">
            <!-- <button mat-icon-button one-icon-button matSuffix *ngIf="element.iconSets === 'yes-icon'" [disabled]="selectTextFormControl.invalid || selectTypeFormControl.invalid" (click)="addNewFeedbackOption(element, inx, selectTypeFormControl.value, selectTextFormControl.value)">
                <mat-icon i18n-aria-label="@@buttons.icon-buttons-example-button" matSuffix class="done-icon">yes</mat-icon>
            </button> -->
            <div>
              <button [matMenuTriggerFor]="feedbackOptionsMenu" mat-icon-button one-icon-button matSuffix>
                <mat-icon i18n-aria-label="@@buttons.icon-buttons-example-button" matSuffix class="more-icon">more_vertical</mat-icon>
              </button>
              <mat-menu #feedbackOptionsMenu="matMenu" xPosition="before" oneMenu>
                <button mat-menu-item (click)="EditMessageTemplate(inx)" class="cf-option-menu-btn">Edit</button>
                <button mat-menu-item (click)="deleteReminderFromTemplate(element, inx)" class="cf-option-menu-btn">Delete</button>
              </mat-menu>
            </div>
            <!-- <button mat-icon-button one-icon-button matSuffix *ngIf="element.iconSets === 'delete-icon'" (click)="deleteReminderFromTemplate(element, inx)">
                <mat-icon i18n-aria-label="@@buttons.icon-buttons-example-button" matSuffix class="delete-icon">delete</mat-icon>
            </button> -->
          </mat-cell>
        </ng-container>

        <!-- <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row> -->

        <mat-row *matRowDef="let row; columns: displayedColumns"
                 [ngClass]="{ disabled: row.disabled }"
                 class="one-element-row reminder-template-row"
                 cdkDrag
                 cdkDragLockAxis="y"
                 [cdkDragDisabled]="row.disabled"></mat-row>
      </mat-table>
    </one-table-content>
  </one-table>
</div>

<ng-template #noRemTemplateView>
  <p title="No Template present, add new Template.">No Template present, add new Template.</p>
</ng-template>
